import React, { useEffect } from "react";
// @material-ui/core components
// core components


import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Button, useTheme } from "@mui/material";


import avatar from "../../assets/img/faces/marc.jpg";
import Layout from "../../core/Layout";

import { getAcceptedNewOffers } from "../../reduxStore/entities/offers";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";


const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};



const columns = [
    { id: 'part_offer_id', label: 'ID', minWidth: 100 },
    { id: 'title', label: 'title', minWidth: 100 },
    { id: 'description', label: 'description', minWidth: 170 },
    { id: 'type', label: 'type', minWidth: 170, },
    { id: 'price', label: 'price', minWidth: 170, },

];
function createData(part_offer_id, title, description, type, price) {

    return { part_offer_id, title, description, type, price };
}

const rows = [
    createData(1, 'Imam ovaj deo', 'Najbolji za te pare', 'used', '100'),
    createData(2, 'Imam ovaj deo', 'Najbolji za te pare', 'used', '100'),
    createData(3, 'Imam ovaj deo', 'Najbolji za te pare', 'new', '100'),

];


export default function AcceptedOffers() {
    let navigate = useNavigate();
    const dispatch = useDispatch();


    const [rows, setRows] = React.useState(handleTableLoad(offers));
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const dataLoaded = useSelector((state) => state.offers.acceptedDataLoaded);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    function handleClick(id) {
        navigate("/admin/offers/" + id);
    }


    useEffect(() => {
        const doasync = (async () => {
            await dispatch(getAcceptedNewOffers());
        })

        doasync();
    }, [dispatch]);


    useEffect(() => {
        setRows(handleTableLoad(offers));
    }, [offers, dataLoaded])


    const theme = useTheme();

    const StyledTableCell = (
        <TableCell style={{
            head: {
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white,
            },
            body: {
                /* fontSize: 14,*/
            },
        }}>

        </TableCell>
    )

    const StyledTableRow = (
        <TableRow style={{
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.action.hover,
                },
            }
        }}>
        </TableRow>
    );

    const offers = useSelector((state) => state.offers.acceptedNewOffers);

    const handleTableLoad = (offers) => {
        const preparedData = offers.map(offer => {
            return createData(offer.part_offer_id, offer.title, offer.description, offer.type, offer.price)
        });
        return preparedData;
    };


    return (
        <Layout>
            <div>
                {dataLoaded ? <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Paper sx={styles.root}>
                            <TableContainer sx={styles.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </StyledTableCell>
                                            ))}
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                            return (
                                                <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <StyledTableCell key={column.id} align={column.align}>
                                                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                    <StyledTableCell>
                                                        <Button variant="contained" onClick={() => handleClick(row.part_offer_id)} >Details</Button>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Paper>
                    </GridItem>
                </GridContainer> : <div>Loading...</div>}
            </div>
        </Layout>
    );
}